<div class="card">
    <div class="card-header d-flex justify-content-between align-items-start">
        <h4>{{ 'MENU.MY_TASK_LIST' | translate}}</h4>
        <a routerLink="/dashboard/my-todo">{{'VIEW_ALL'|translate}}</a>
    </div>
    <div class="card-body">
        <div *ngIf="myTask?.length < 1">{{'YOU_HAVE_NO_TASK' | translate}}</div>
        <div *ngFor="let task of myTask" class="row mb-1">
            <div class="col-9" [ngClass.sm]="'pr-0'">
                <div class="d-flex align-items-center">
                    <div class="avatar-group" *ngIf="task.status !== 0">
                        <div placement="right"
                             [ngbTooltip]="task.status === 1 ? ('IN_PROGRESS_FROM' | translate) + task.status_changer.complete_name : ('COMPLETED_FROM' | translate) + task.status_changer.complete_name"
                             class="avatar">
                            <img #picture (error)="picture.hidden = true" [src]="task.status_changer.avatar" alt="Avatar" height="32" width="32"
                                 class="cover border-3-{{task.status === 1 ? 'warning' : 'success'}} border-"/>
                            <div *ngIf="task.status === 1 && task.status === 2 && picture.hidden"
                                 class="avatar-content text-uppercase">{{ task.status_changer.complete_name | initials }}</div>
                        </div>
                    </div>
                    <div class="avatar bg-light-secondary avatar-md" *ngIf="task.status === 0">
                        <div class="avatar-content">
                            <span [data-feather]="'user'" [class]="'avatar-icon'"></span>
                        </div>
                    </div>
                    <span class="ml-1 text-break-line-1">
                        <a [routerLink]="'/dashboard/my-todo'" [queryParams]="{task: task?.id}" [ngbTooltip]="task?.title?.length > 15 ? task.title : null">{{task.title}}</a>
                    </span>

                </div>
            </div>
            <div class="col-3" [ngClass.sm]="'pl-0'">
                <div class="d-flex align-items-center mt-05">
                    <small class="text-nowrap text-muted font-small-3 text-capitalize">{{_utilsService.formatDate(task.end_date, "DD MMM")}}</small>
                    <div class="badge-wrapper mx-1">
                        <span [ngbTooltip]="'LOW_PRIORITY' | translate" placement="left" *ngIf="task.priority === 0">
                            <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
                        </span>
                        <span [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="left" *ngIf="task.priority === 1">
                            <i [data-feather]="'flag'" size="20" class="text-warning"></i>
                        </span>
                        <span [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="left" *ngIf="task.priority === 2">
                            <i [data-feather]="'flag'" size="20" class="text-danger"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-7 mt-05">
                <button type="button" rippleEffect class="btn btn-outline-primary btn-block" (click)="_utilsService.popupOpenTaskIsOpen = true">{{'ADD_TASK' | translate}}</button>
            </div>
        </div>
    </div>
</div>

